import React, { useEffect, useImperativeHandle, useRef, useState } from 'react';
import style from './xscrolleasy.module.css'
import { useThrottle } from '../../../utils/hooks';

const XscrollEasy = React.forwardRef(({ children, disableScrollingDom, disableYScroll = false, contentGap = '8px', fullHeight }, ref) => {

  const stylizedContent = useRef(null)
  const xscollContent = useRef(null)
  const [deltaY, setDeltaY] = useState(0);
  const [xcrolling, setXcrolling] = useState(false);

  useImperativeHandle(ref, () => ({
    xcrolling: xcrolling
  }), [xcrolling])

  useEffect(() => {
    const scrollBox = stylizedContent.current;
    let startX;
    let startScrollTop;
    // 兼容触屏滑动
    const touchStart = (event) => {
      startX = event.touches[0].pageX;
      startScrollTop = scrollBox.scrollTop;
    };
    const touchMove = (event) => {
      const currentX = event.touches[0].pageX;
      const diffX = startX - currentX;
      scrollBox.scrollTop = startScrollTop + diffX;

      // 创建并触发一个模拟的wheel事件
      const wheelEvent = new WheelEvent('wheel', {
        deltaX: diffX, // 模拟横向滑动的位移作为deltaX
        deltaY: 0, // Y方向位移为0
        clientX: currentX,
        clientY: event.touches[0].clientY,
        bubbles: true,
        cancelable: true,
      });
      scrollBox.dispatchEvent(wheelEvent);
      event.preventDefault();
    };
    const wheel = (event) => {
      if (event.deltaX) {
        event.preventDefault();
        scrollBox.scrollTop += event.deltaX;
      }

      if (event.deltaY && disableYScroll) {

        event.preventDefault();
      }
    };

    scrollBox.addEventListener('touchstart', touchStart, { passive: false });
    scrollBox.addEventListener('touchmove', touchMove, { passive: false });
    scrollBox.addEventListener('wheel', wheel, { passive: false });
    return () => {
      scrollBox.removeEventListener('touchstart', touchStart, { passive: false });
      scrollBox.removeEventListener('touchmove', touchMove, { passive: false });
      scrollBox.removeEventListener('wheel', wheel, { passive: false });
    };
  }, []);

  const handlerWheel = (e) => {
    const speed = 40
    const pWidth = stylizedContent.current?.clientWidth
    const sWidth = xscollContent.current?.clientWidth
    if (sWidth <= pWidth) return
    if (e.deltaX > 0) {
      if (-deltaY < sWidth - pWidth) {
        setDeltaY(pre => pre - speed)
      }
    } else if (e.deltaX < 0) {
      if (deltaY < 0) {
        setDeltaY(pre => pre + speed)
      }
    } else if (e.deltaY > 0) {
      if (-deltaY < sWidth - pWidth) {
        setDeltaY(pre => pre - speed)
      }
    } else if (e.deltaY < 0) {
      if (deltaY < 0) {

        setDeltaY(pre => pre + speed)
      }
    }

  }

  const handlerStartParentScroll = () => {
    if (disableScrollingDom) {
      disableScrollingDom.style.overflowY = 'scroll'
    }
  }
  const handlerStopParentScroll = () => {
    if (disableScrollingDom) {
      disableScrollingDom.style.overflowY = 'hidden'
    }
  }

  const throttlMove = useThrottle((e, operate, startX, transformX, sWidth, pWidth, transformContent) => {
    e.stopPropagation()
    const endX = operate === 'mouse' ? e.clientX : e.touches[0].clientX;
    const diff = endX - startX
    if (transformX + diff + sWidth < pWidth) return
    if (transformX + diff > 15) return
    transformContent.style.transform = `translateX(${transformX + diff}px)`
  }, 0)

  const handleScrollStart = (operate, e) => {
    if (operate === 'mouse' && e.button !== 0) return;
    if (operate === 'touch' && e.touches.length !== 1) return;
    setXcrolling(true)
    xscollContent.current.style.transition = 'none'
    const pWidth = stylizedContent.current?.clientWidth
    const sWidth = xscollContent.current?.clientWidth
    const transformContent = xscollContent.current
    const transformX = +transformContent.style.transform.replace('translateX(', '').replace('px)', '')
    e.stopPropagation()
    const startX = operate === 'mouse' ? e.clientX : e.touches[0].clientX;
    const handleMove = (e) => throttlMove(e, operate, startX, transformX, sWidth, pWidth, transformContent)

    const handleEnd = () => {
      setXcrolling(false)
      if (operate === 'mouse') {
        document.removeEventListener('mousemove', handleMove);
        document.removeEventListener('mouseup', handleEnd);
      } else {
        document.removeEventListener('touchmove', handleMove);
        document.removeEventListener('touchend', handleEnd);
        document.removeEventListener('touchcancel', handleEnd);
      }
    }

    if (operate === 'mouse') {
      document.addEventListener('mousemove', handleMove);
      document.addEventListener('mouseup', handleEnd);
    } else {
      document.addEventListener('touchmove', handleMove);
      document.addEventListener('touchend', handleEnd);
      document.addEventListener('touchcancel', handleEnd);
    }
    if (e.preventDefault) {
      e.preventDefault();
    }
  }

  return (
    <div
      className={`${style.stylizedContent} ${fullHeight ? "h-full" : ''}`}
      id='xscrolleasy'
      ref={stylizedContent}
      onWheel={handlerWheel}
      onMouseDown={handleScrollStart.bind(null, 'mouse')}
      onTouchStart={handleScrollStart.bind(null, 'touch')}
      onMouseEnter={handlerStopParentScroll}
      onMouseLeave={handlerStartParentScroll}
    >
      <div
        className={`${style.xscollContent} ${fullHeight ? "h-full" : ''}`}
        ref={xscollContent}
        style={{
          transform: `translateX(${deltaY}px)`,
          gap: contentGap
        }}>
        {children}
      </div>
    </div>
  )
})
XscrollEasy.displayName = 'XscrollEasy'
export { XscrollEasy }